import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

/* Put all uiSchema options here, in the template they go under ui:options: */
export const InputGroupArrayCardUiOptionsSchema = z.object({
  lockFirstRow: z.boolean().optional(),
  ownerFieldName: z.string().optional(),
  ownerRoleLabel: z.string().optional(),
});

// Transforms the Zod schema to a TypeScript type
export type InputGroupArrayCardUiOptions = z.infer<
  typeof InputGroupArrayCardUiOptionsSchema
>;

/* The field schema for the InputGroupArrayCard field extension */
export const InputGroupArrayCardFieldSchema = makeFieldSchemaFromZod(
  z.array(z.object({})).describe('Array Two Fields In Card'),
  InputGroupArrayCardUiOptionsSchema,
);

// Transforms the field schema props to a TypeScript type
export type InputGroupArrayCardFieldProps =
  typeof InputGroupArrayCardFieldSchema.type;

/* The final schema used for the field extension */
export const InputGroupArrayCardSchema = InputGroupArrayCardFieldSchema.schema;
